// Shared constants for the Quick Check (Chance calculator) UI. Extracted
// from `AdmissionCalculator.jsx` so both the page and its child components
// import from a single source of truth — order and colour language MUST
// match the admission-chance band ordering in `backend/ai_advisor.py`.

export const CURRICULA = [
  { value: "a_level", label: "A Levels" },
  { value: "ib", label: "IB Diploma" },
  { value: "atar", label: "ATAR (Australia)" },
  { value: "cbse", label: "CBSE (India, %)" },
  { value: "isc", label: "ISC / CISCE (India, %)" },
  { value: "american_diploma", label: "American Diploma (GPA)" },
  { value: "gpa", label: "GPA (other)" },
  { value: "ap_composite", label: "AP composite (US)" },
  { value: "abitur", label: "Abitur (Germany)" },
  { value: "french_bac", label: "Baccalauréat (France)" },
  { value: "hkdse", label: "HKDSE (Hong Kong)" },
  { value: "suneung", label: "Suneung / CSAT (South Korea)" },
];

// Band metadata for the per-country chip picker. Order = display order,
// which flows likely → target → ambitious → long-shot so the applicant
// reads their best matches first.
export const BAND_META = [
  { key: "likely",           label: "Likely",     tone: "emerald" },
  { key: "target",           label: "Target",     tone: "amber"   },
  { key: "ambitious",        label: "Ambitious",  tone: "orange"  },
  { key: "highly_ambitious", label: "Long-shot",  tone: "red"     },
];

// Tone class lookup — kept out of every render call so the JSX stays
// declarative and the class strings live somewhere greppable.
export const BAND_TONE_CLASSES = {
  emerald: {
    off: "border-emerald-200 text-emerald-800 hover:bg-emerald-50",
    on:  "border-emerald-600 bg-emerald-600 text-white",
  },
  amber: {
    off: "border-amber-300 text-amber-800 hover:bg-amber-50",
    on:  "border-amber-500 bg-amber-500 text-white",
  },
  orange: {
    off: "border-orange-300 text-orange-800 hover:bg-orange-50",
    on:  "border-orange-600 bg-orange-600 text-white",
  },
  red: {
    off: "border-red-300 text-red-800 hover:bg-red-50",
    on:  "border-red-600 bg-red-600 text-white",
  },
};

// Chip pill classes for the "Within reach" escape-hatch — same colour
// language as `BAND_TONE_CLASSES` but expressed as a solid pill so the
// escape hatch feels visually distinct from the band picker.
export const WITHIN_REACH_TONE_MAP = {
  likely:           "text-emerald-700 bg-emerald-50 border-emerald-200",
  target:           "text-amber-700   bg-amber-50   border-amber-200",
  ambitious:        "text-orange-700  bg-orange-50  border-orange-200",
  highly_ambitious: "text-red-700     bg-red-50     border-red-200",
};

// Per-country + global escape-hatch threshold. If <30% of matches are
// Likely+Target, we surface the WUA+ tutoring/attestation panel.
// Kept as a named constant so any product tweak lands in one place.
export const ESCAPE_HATCH_POSITIVE_THRESHOLD = 0.30;
